import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'

import {
    GROUP_SETTINGS_PAGE_SET_GROUP,
    GROUP_SETTINGS_PAGE_SET_TRIAL,
    GROUP_SETTINGS_PAGE_SET_TRIALGROUP
} from '../../actions/pages/groupSettingsPage';


export interface IGroupSettingsPageState {
    groupId: number;
    trialId: number;
    trialGroupId: number;
}

const initialState: IGroupSettingsPageState = {
    groupId: undefined,
    trialId: undefined,
    trialGroupId: undefined
};


function setGroup(state: IGroupSettingsPageState, groupId: number): IGroupSettingsPageState {
    const newState: IGroupSettingsPageState = update(state, {
        groupId: {
            $set: groupId
        }
    });
    return newState;
}

function setTrial(state: IGroupSettingsPageState, trialId: number): IGroupSettingsPageState {
    const newState: IGroupSettingsPageState = update(state, {
        trialId: {
            $set: trialId
        }
    });
    return newState;
}

function setTrialGroup(state: IGroupSettingsPageState, trialGroupId: number): IGroupSettingsPageState {
    const newState: IGroupSettingsPageState = update(state, {
        trialGroupId: {
            $set: trialGroupId
        }
    });
    return newState;
}

const GroupSettingsPageReducer: Reducer<IGroupSettingsPageState> = (state: IGroupSettingsPageState = initialState, action) => { 
    switch (action.type) {
        case GROUP_SETTINGS_PAGE_SET_GROUP:
            return setGroup(state, action.groupId);
        case GROUP_SETTINGS_PAGE_SET_TRIAL:
            return setTrial(state, action.trialId);
        case GROUP_SETTINGS_PAGE_SET_TRIALGROUP:
            return setTrialGroup(state, action.trialGroupId);
    }

    return state;
}

export default GroupSettingsPageReducer;